<template>
  <div class="search-configuration-prompt">
    <div class="search-configuration-prompt-wrap">
      <div class="image">
        <img src="../assets/empty-cart.png" alt="Search for configuration">
      </div>
      <div class="content">
        <h2>Please search for your configuration</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchConfigurationPrompt',
};
</script>

<style lang="scss" scoped>
.search-configuration-prompt {
  margin: auto;
  text-align: center;

  .image {
    line-height: 0;
  }

  h2 {
    font-weight: 700;
    font-size: 30px;
    line-height: 102%;
    color: #060606;
    font-family: var(--primary-font);
    margin-bottom: 1px;
  }
}
</style>
